export default __webpack_public_path__ + "static/media/10AW1FEB66.bc8ee487.jpg";